/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type FollowUserMutationVariables = Types.Exact<{
  userID: Types.Scalars['ID']['input'];
}>;


export type FollowUserMutation = { __typename?: 'Mutation', userFollow: boolean };

export type UnfollowUserMutationVariables = Types.Exact<{
  userID: Types.Scalars['ID']['input'];
}>;


export type UnfollowUserMutation = { __typename?: 'Mutation', userUnfollow: boolean };


export const FollowUserDocument = `
mutation followUser($userID: ID!) {
  userFollow(userID: $userID)
}

`

export const followUserMutationKey = 'followUser'

export function followUserMutationFetcher(variables: FollowUserMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<FollowUserMutation, FollowUserMutationVariables>(FollowUserDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useFollowUserMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<FollowUserMutation, E, FollowUserMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<FollowUserMutation, E, FollowUserMutationVariables, C>({
        ...options,
        mutationKey: [followUserMutationKey],
        mutationFn: (variables: FollowUserMutationVariables) => followUserMutationFetcher(variables, fetchOptions),
    })
}

export const UnfollowUserDocument = `
mutation unfollowUser($userID: ID!) {
  userUnfollow(userID: $userID)
}

`

export const unfollowUserMutationKey = 'unfollowUser'

export function unfollowUserMutationFetcher(variables: UnfollowUserMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<UnfollowUserMutation, UnfollowUserMutationVariables>(UnfollowUserDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useUnfollowUserMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<UnfollowUserMutation, E, UnfollowUserMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<UnfollowUserMutation, E, UnfollowUserMutationVariables, C>({
        ...options,
        mutationKey: [unfollowUserMutationKey],
        mutationFn: (variables: UnfollowUserMutationVariables) => unfollowUserMutationFetcher(variables, fetchOptions),
    })
}